import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController, AlertController, ModalController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { LoginPage } from '../../login/login';
import { Database } from '../../../providers/database';
import { Translate } from '../../../providers/translate';
import { AuthData } from '../../../providers/auth';
import * as firebase from 'firebase';

@IonicPage()
@Component({
  selector: 'page-catalog',
  templateUrl: 'catalog.html',
})
export class Catalog {

  client: any;
  event: any;
  dataCatalog: any;
  textTranslate: any;

  constructor(public navCtrl: NavController, public params: NavParams, public db: Database, public loadingCtrl: LoadingController, public toastCtrl: ToastController, translate: Translate, public auth: AuthData, public alertCtrl: AlertController, public translateProvider: TranslateService, public modalCtrl: ModalController) {
    translate.translateGroup(['Cargando', 'Se ha agregado el producto al carrito de compra', 'Ingrese la cantidad de items', 'Número de items', 'Cancelar', 'Aceptar', 'Debe iniciar sesión antes de continuar']).
    then(result => {
      this.textTranslate = result;
    });

    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.dataCatalog = this.params.get('dataCatalog');

    if (this.params.get('addToPay')) {
      let loader = this.loadingCtrl.create();
      loader.present();

      setTimeout(() => {
        loader.dismiss();
        this.add(this.dataCatalog);
      }, 600);
    }
  }

  add(catalog) {
    let loader = this.loadingCtrl.create({
      content: this.textTranslate['Cargando'],
      dismissOnPageChange: true
    });

    if (this.auth.getUser().isAnonymous) {
      let modal = this.modalCtrl.create(LoginPage, {client: this.client, event: this.event});
      modal.present();

      let toast = this.toastCtrl.create({
        message: this.textTranslate["Debe iniciar sesión antes de continuar"],
        duration: 5000,
        position: 'top'
      });
      toast.present();
    } else {
      let alert = this.alertCtrl.create({
        title: this.event.title[this.translateProvider.getDefaultLang()],
        message: this.textTranslate['Ingrese la cantidad de items'],
        inputs: [{
          name: 'quantity',
          placeholder: this.textTranslate['Número de items'],
          type: 'number',
          value: '1'
        }],
        buttons: [
          {
            text: this.textTranslate['Cancelar'],
            role: 'cancel',
            handler: () => {false}
          },
          {
            text: this.textTranslate['Aceptar'],
            handler: (data) => {
              if (data.quantity) {
                loader.present();

                delete(catalog.$key);
                delete(catalog.$exists);

                catalog.quantity = data.quantity;

                console.log('Catalogo', catalog);

                this.db.pushData('/Clients/' + this.client.url + '/___CartUsers/' + this.auth.getUser().uid, catalog).then((result) => {

                  firebase.database().ref().child('/Clients/' + this.client.url + '/Users/' + this.auth.getUser().uid + '/numCartPending').
                  transaction(function(currentCount) {
                    return currentCount + 1;
                  });

                  let toast = this.toastCtrl.create({
                      message: this.textTranslate["Se ha agregado el producto al carrito de compra"],
                      duration: 5000,
                      // position: 'top'
                  });
                  toast.present();
                  this.navCtrl.pop();
                })
                .catch(error => {
                    let toast = this.toastCtrl.create({
                      message: error,
                      duration: 5000,
                      dismissOnPageChange: true
                    });
                    loader.dismiss();
                    toast.present();
                });
              } else {
                return false;
              }
            }
          }
        ]
      });
      alert.present();
    }
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-catalogs/catalog/catalog.ts